import styled from 'styled-components'

export const TextContainer = styled.p`
    display: -webkit-box;
    line-height: 12px;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    font-size: 9px;
    font-family: ${({ theme }) => theme['font-regular']};

    color: ${({ theme }) => theme['gray-900']};
    /* background: ${({ theme }) => theme['gray-100']}; */
    margin: 0;
`
